import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModuleShareRead, ModuleSharesPayload } from '../models/module-v1-read.model';

@Injectable()
export class ModuleSharingService {
    private readonly endpoint = '/api/module_manager/v1/workspace/modules';
    private readonly jsonContentType = { headers: { 'Content-Type': 'application/json' } };

    constructor(private http: HttpClient) {}

    updateModuleShares(moduleShares: ModuleShareRead[], moduleId: string): Observable<ModuleSharesPayload> {
        return this.http.put(`${this.endpoint}/${moduleId}/shares`, { moduleShares }, this.jsonContentType) as Observable<ModuleSharesPayload>;
    }

    getModuleSharesWithUserdata(moduleId: string): Observable<ModuleSharesPayload> {
        return this.http.get(`${this.endpoint}/${moduleId}/shares`, this.jsonContentType) as Observable<ModuleSharesPayload>;
    }
}
